import { collections } from '@/mocks/home';

export default function CollectionsSection() {
  return (
    <section id="collections" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="reveal flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="flex items-center gap-2 font-label text-xs tracking-[0.3em] text-secondary-700">
              <i className="ri-stack-line text-[14px]" />
              COLLECTIONS
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              专题合集
            </h2>
          </div>
          <p className="max-w-md font-body text-sm text-foreground-600">
            按题材归档，每个合集都在持续追加新线索，读起来是一条完整脉络，而不是零散传闻。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item) => (
            <article
              key={item.title}
              className="reveal group cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} 专题合集 - 黑料网曝内幕`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
                />
                <span className="absolute right-3 top-3 rounded-md bg-accent-500 px-2.5 py-1 font-label text-[11px] font-medium text-background-50">
                  {item.count}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-[17px] font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <i className="ri-arrow-right-line text-lg text-foreground-400 transition-colors group-hover:text-primary-600" />
                </div>
                <p className="mt-2.5 font-body text-[13.5px] leading-relaxed text-foreground-600">
                  {item.note}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}